/**
 * Created by hp on 2017/6/30.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import Config from '../../config'
import { Medal, MedalModal } from '../../components/medal'

import '../../styles/channel/ChannelLiveroomBar.css';

class ChannelLiveroomBar extends Component {
    constructor() {
        super();
        this.handleToggleFollow = this.handleToggleFollow.bind(this);
        this.handleToLiveroom = this.handleToLiveroom.bind(this);
        this.state = {
            isShowMedalModal: false,
            medalType: '',
        }
    }

    handleToLiveroom() {
        const {liveroom} = this.props;
        let search = location.search.indexOf('pgy') > -1 ? location.search : ''
        window.location = `/liveroom/${liveroom.id}${search}`
    }

    handleToggleFollow() {
        const {isFans, liveroom, subscribed} = this.props;

        if (subscribed && isFans) {
            axios.post(`/api/liveroom/${liveroom.id}/unfollow`).then(res => {
                if (res.data.code === 0) {
                    this.props.dispatch({type: 'CHANNEL_UNSET_FANS'});
                    this.context.page.showToast('取消关注成功')
                } else {
                    this.context.page.showAlert(res.data.msg);
                }
            });
        } else {
            this.props.dispatch({ type: 'MTA_CLICK', payload: 'lecture-bottom-liveroom-bar-click-to-follow' })
            this.props.dispatch({
                type: 'SHOW_FOLLOW_LIVEROOM',
                payload: {
                    liveroom: liveroom
                }
            })
        }
    }

    onClickMedal (type) {
        this.setState({ isShowMedalModal: true, medalType: type })
    }

    render() {
        const {isFans, isManager, liveroom, isPresentPage} = this.props;

        return (
            <div className="channel-liveroom-bar box">
                <div className="channel-liveroom-container default-hover" onClick={this.handleToLiveroom}>
                    <div className="channel-liveroom-bar_icon">
                        <div className="liveroom-slidetop-content-main-type">
                            {
                                liveroom.verify_type === 2 &&
                                <i className="iconfont verify-type-icon icon-yfv">
                                </i>
                            }
                            {
                                liveroom.verify_type === 1 &&
                                <i className="iconfont verify-type-icon verify-type-icon-special icon-yfv">
                                </i>
                            }
                        </div>
                        <div className="channel-liveroom-bar_icon-img">
                            <img src={liveroom.avatar_url} alt=""/>
                        </div>
                    </div>
                    <div className="channel-liveroom-bar_mess">
                        <p className="channel-liveroom-bar_mess-name">
                            {liveroom.name}
                            {
                                liveroom.badges.map(item => (
                                    <Medal 
                                        type={item} 
                                        onClickMedal={e => this.onClickMedal(item)}
                                        style={{width: '18px', marginTop: '1px'}}
                                        key={item}
                                    />
                                ))
                            }
                        </p>
                        <p className="channel-liveroom-bar_mess-count">{liveroom.follower_count}人关注</p>
                    </div>
                </div>
                {(!isManager && !isPresentPage) ?
                    (!isFans ?
                            <div className="channel-liveroom-bar_focus" onClick={this.handleToggleFollow}>
                                关注
                            </div>
                            :
                            <div className="channel-liveroom-bar_focus-on">
                                已关注
                            </div>
                    )
                    :
                    null
                }
                <MedalModal 
                    show={this.state.isShowMedalModal} 
                    onClickClose={() => this.setState({ isShowMedalModal: false })} 
                    isShowBtn={this.props.isManager}
                    type={this.state.medalType}
                    liveroomId={this.props.liveroom.id}
                />
            </div>
        )
    }
}

ChannelLiveroomBar.contextTypes = {
    page: React.PropTypes.object
};

export default connect((state) => ({
    liveroom: state.channel.liveroom,
    isFans: state.channel.role.is_fans,
    isManager: state.channel.role.is_manager,
    subscribed: state.account.subscribed,
}))(ChannelLiveroomBar);


// WEBPACK FOOTER //
// ./src/components/channel/ChannelLiveroomBar.js